import {DataFetcher} from '@aboutyou/data-fetcher';
import {MetadataResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/hub_page/service.types';
import {Head} from '@aboutyou/head-elements';
import {TrackContentPageView} from '@aboutyou/tracking';
import React, {memo} from 'react';
import {
  extractMetaAndLinkTags,
  isSeoData,
  setDataTestIds,
} from '../../../shared-deprecated/metaUtils';
import {useUpdateTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';
import {useHubTypeFromSlug} from '../utils/useHubTypeFromSlug';
import {useGetHubPageMeta} from './utils/useGetHubPageMeta';

export const HubPageMeta = () => {
  return (
    <DataFetcher
      request={useGetHubPageMeta()}
      Error={null}
      View={MemoHubPageMetaView}
    />
  );
};

const HubPageMetaView: React.FC<MetadataResponse> = ({
  meta,
  recommendedTargetGroup,
}) => {
  const hubType = useHubTypeFromSlug();
  useUpdateTargetGroup(recommendedTargetGroup);

  if (!isSeoData(meta)) {
    return null;
  }

  const seoData = meta.type.seoData;
  const [metaTags, linkTags] = setDataTestIds(
    extractMetaAndLinkTags(seoData.elements),
  );

  return (
    <>
      <TrackContentPageView
        pageTitle={seoData.title}
        overridePageProps={{type: hubType}}
      />
      <Head meta={metaTags} link={linkTags}>
        <title data-testid="MetaTitle">{seoData.title}</title>
      </Head>
    </>
  );
};

const MemoHubPageMetaView = memo(HubPageMetaView);
